<template>
  <div id="app">
    <ContainerWithNav>
      <router-view />
    </ContainerWithNav>
    <InactiveNotice />
  </div>
</template>

<script>
import ContainerWithNav from '@/components/PageContainers/ContainerWithNav/ContainerWithNav.vue'
import InactiveNotice from '@/components/Authentication/InactiveNotice/InactiveNotice.vue'

export default {
  components: {
    ContainerWithNav,
    InactiveNotice
  },
  data() {
    return {
      heartbeat: null
    }
  },
  mounted() {
    this.heartbeat = setInterval(() => {
      this.$store.dispatch('authHeartbeat')
    }, process.env.VUE_APP_HEARTBEAT_MS)
  }
}
</script>

<style lang="scss"></style>
